import { UserIcon } from "@landtechnologies/components";

type FullNameRowProps = {
  fullName: string;
};

export const FullNameRow = ({ fullName }: FullNameRowProps) => {
  return (
    <div data-testid="your-account-element" className="atlas-flex atlas-items-center atlas-gap-2">
      <UserIcon />
      <span>{fullName}</span>
    </div>
  );
};
